import { WorkspacePremiumOutlined } from '@mui/icons-material'
import { Box, Button, Typography } from '@mui/material'
import Header from 'components/header'
import Loading from 'components/loading'
import Page from 'components/page'
import Wrapper from 'components/wrapper'
import { useAlert } from 'contexts/alert'
import { useAuthentications } from 'contexts/authentications'
import { useCallback, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from 'services/api'
import AuthenticationsHeaderRevogation from '../header-revogation'
import RemoveCertificateModal from '../remove-certificate-modal'
import { useStyles } from './styles'

interface IRouteParams {
  id: string
  name: string
}

const AuthenticationBox = () => {
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const classes = useStyles()
  const { openAlert } = useAlert()
  const { refetchValidate } = useAuthentications()

  const { id, name } = useParams<IRouteParams>()
  const { connectors, isLoading: loading, validate } = useAuthentications()

  const handleOpenModal = () => setOpenModal((prev) => !prev)

  const handleRemoveCertificate = useCallback(async () => {
    setIsLoading(true)
    try {
      await api.delete('/users/delete-certificate')
      openAlert('Remoção de certificado feita com sucesso', 'success')
      window.location.reload()
    } catch (error) {
      openAlert('Erro ao remover certificado', 'error')
    } finally {
      setIsLoading(false)
    }
  }, [])

  if (isLoading || loading) {
    return (
      <Box className={classes.root}>
        <Loading />
      </Box>
    )
  }

  return (
    <Wrapper>
      <Header>
        <AuthenticationsHeaderRevogation />
      </Header>

      <Page>
        <Box className={classes.root}>
          <Box className={classes.certificateContainer}>
            <WorkspacePremiumOutlined fontWeight={700} />

            <Typography className={classes.certificate}>
              {validate !== null ? 'Certificado Digital A1' : 'Autenticação inexistente'}
            </Typography>
          </Box>

          <Box>
            <Button
              variant='text'
              color='anger'
              className={classes.buttonDescription}
              onClick={handleOpenModal}
              disabled={validate !== null ? false : true}
            >
              Remover autenticação
            </Button>
          </Box>
        </Box>

        <RemoveCertificateModal
          openModal={openModal}
          setOpenModal={handleOpenModal}
          removeCertificate={handleRemoveCertificate}
        />
      </Page>
    </Wrapper>
  )
}

export default AuthenticationBox
